<template>
  <div class="app-container">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="160px"
    >
      <el-form-item label="banner图片" prop="banners">
        <el-upload
          name="file[]"
          :data="{ type: 'image' }"
          class="avatar-uploaders1"
          :action="ossUpload"
          accept=".jpg,.png,.jpeg"
          :headers="{ token: token }"
          list-type="picture-card"
          :show-file-list="true"
          :file-list="fileList"
          :limit="6"
          :on-remove="
            (file, fileList) => {
              handleRemovePic(file, fileList, 'banners');
            }
          "
          :on-success="
            (res, file, fileList) => {
              handleAvatarSuccess(res, file, fileList, 'banners');
            }
          "
          :disabled="cztype == 'see'"
          :on-exceed="() => exceed('banner图片', 6)"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
        ><!-- 已修改 -->
        <div class="pic-tips">banner图宽高比建议 1.8:1</div>
      </el-form-item>
      <el-form-item label="入驻公司logo图" prop="company_img">
        <el-upload
          name="file[]"
          :data="{ type: 'image' }"
          class="avatar-uploaders1"
          :action="ossUpload"
          accept=".jpg,.png,.jpeg"
          :headers="{ token: token }"
          list-type="picture-card"
          :show-file-list="true"
          :limit="6"
          :file-list="companyImgList"
          :on-remove="
            (file, fileList) => {
              handleRemovePic(file, fileList, 'company_img');
            }
          "
          :on-success="
            (res, file, fileList) => {
              handleAvatarSuccess(res, file, fileList, 'company_img');
            }
          "
          :disabled="cztype == 'see'"
          :on-exceed="() => exceed('入驻公司logo图', 6)"
        >
          <i class="el-icon-plus avatar-uploader-icon"></i> </el-upload
        ><!-- 已修改 -->
        <div class="pic-tips">logo图宽高比建议 2.5:1</div>
      </el-form-item>
      <el-form-item label="宣传视频" prop="video">
        <el-upload
          name="file[]"
          :action="ossUpload"
          :headers="{ token: token }"
          :data="{ type: 'video' }"
          accept="video/mp4"
          list-type="picture-card"
          :show-file-list="false"
          :on-error="videoErr"
          :on-progress="videoProgross"
          :on-success="handleVideoSuccess"
          :disabled="cztype == 'see'"
        >
          <el-progress
            v-if="percentage != 0 && percentageShow"
            type="circle"
            :percentage="percentage"
          ></el-progress>
          <div class="video-box" v-if="ruleForm.video">
            <div class="handles">
              <i class="el-icon-delete" @click.stop="delVideo"></i>
            </div>
            <video controls :src="imageOss + ruleForm.video" />
          </div>
          <i class="el-icon-plus avatar-uploader-icon" v-else></i> </el-upload
        ><!-- 已修改 -->
      </el-form-item>
      <el-form-item label="联系地址名称" prop="address_name">
        <el-input
          class="w4"
          v-model="ruleForm.address_name"
          placeholder="联系地址名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="address_detail">
        <el-input
          type="textarea"
          :rows="2"
          class="w4"
          v-model="ruleForm.address_detail"
          placeholder="请输入详细地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="地理坐标（纬度）" prop="point_lat">
        <el-input
          class="w4"
          v-model="ruleForm.point_lat"
          placeholder="请输入地理坐标（纬度）"
        ></el-input>
      </el-form-item>
      <el-form-item label="地理坐标（经度）" prop="point_lng">
        <el-input
          class="w4"
          v-model="ruleForm.point_lng"
          placeholder="请输入地理坐标（经度）"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系电话" prop="tel">
        <el-input
        maxlength="11"
          class="w4 numInput"
          type="number"
          v-model="ruleForm.tel"
          placeholder="请输入联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item v-if="roles.includes('/business/save_invest')">
        <el-button
          v-if="cztype == 'add'"
          type="primary"
          @click="submitForm('ruleForm')"
        >
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { save_invest, get_invest } from "@/api/investment";
import { openPark, delImage } from "@/api/index";
import { getToken } from "@/utils/auth";
export default {
  computed: {
    ...mapGetters(["roles", "userInfo", "imageUrl", "imageOss"]),
  },
  data() {
    return {
      token: getToken(),
      ruleForm: {},
      fileList: [],
      companyImgList: [],
      rules: {
        banners: [{ required: true, message: "请选择banner图片" }],
        company_img: [{ required: true, message: "请选择入驻公司logo图" }],
        address_name: [
          { required: true, message: "请输入地点名称", trigger: "blur" },
        ],
        address_detail: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        point_lat: [
          {
            required: true,
            message: "请输入地理坐标（纬度）",
            trigger: "blur",
          },
        ],
        point_lng: [
          {
            required: true,
            message: "请输入地理坐标（经度）",
            trigger: "blur",
          },
        ],
        video: [{ required: true, message: "请选择宣传视频", trigger: "blur" }],
        tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
      },
      cztype: "add",
      ossUpload: this.$store.state.ossUpload,
      clearPics: [],
      percentage: 0,
      percentageShow: true,
      clearVideos: [],
    };
  },
  created() {
    // if (this.userInfo.park_id !== 0) {
    //   this.screen.park_id = this.userInfo.park_id;
    // } else {
    //   this.screen.park_id = "";
    // }
    this.fileList = [];
    this.getInfo();
  },
  methods: {
    exceed(msg, num) {
      this.$message.warning(`${msg}仅限${num}张，请先移除原有图片！`);
    },
    delVideo() {
      this.clearVideos.push(this.ruleForm.video);
      this.ruleForm.video = "";
    },
    videoProgross(e) {
      this.percentage = parseInt(e.percent);
    },
    handleVideoSuccess(res) {
      this.percentageShow = false;
      if (res.code === 200) {
        this.ruleForm.video = res.data.url;
      } else {
        this.$message.error("上传失败，" + res.msg);
      }
    },
    videoErr() {
      this.$message.error("上传失败");
    },
    handleRemovePic(file, fileList, type) {
      if (file.response.data.url) {
        this.clearPics.push(file.response.data.url);
      }
      var list = [];
      list = fileList.map((item) => {
        return item.response.data.url;
      });
      this.ruleForm[type] = list.join(",");
    },
    delImges() {
      if (this.clearPics.length) {
        delImage({ file: this.clearPics.join(",") }).then((ress) => {});
      }
      if (this.clearVideos.length) {
        delImage({ file: this.clearVideos.join(",") }).then((ress) => {});
      }
    },
    handleAvatarSuccess(res, file, fileList, type) {
      if (res.code === 200) {
        var list = [];
        list = fileList.map((item) => {
          return item.response.data.url;
        });
        this.ruleForm[type] = list.join(",");
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
        var list = [];
        fileList.map((item) => {
          if (item.response.code == 200) {
            list.push({
              name: +new Date(),
              url: imageOss + item.response.data.url,
              response: {
                data: {
                  url: item.response.data.url,
                },
              },
            });
          }
        });
        this.fileList = list;
      }
    },
    // 获取信息
    getInfo() {
      var that = this;
      get_invest().then((res) => {
        if (!res.data.invest_config) {
          return;
        }
        that.ruleForm = {
          banners: res.data.invest_config.banners || [],
          video: res.data.invest_config.video || "",
          company_img: res.data.invest_config.company_img || [],
          address_name: res.data.invest_config.address_name || "",
          address_detail: res.data.invest_config.address_detail || "",
          point_lat: res.data.invest_config.point_lat || "",
          point_lng: res.data.invest_config.point_lng || "",
          tel: res.data.invest_config.tel
            ? Number(res.data.invest_config.tel)
            : null,
        };
        var bannerList = res.data.invest_config.banners.split(",");
        this.fileList = bannerList.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });

        var companyImgList = res.data.invest_config.company_img.split(",");
        this.companyImgList = companyImgList.map((item) => {
          return {
            name: +new Date(),
            url: this.imageOss + item,
            response: {
              data: {
                url: item,
              },
            },
          };
        });
      });
    },
    submitForm(formName) {
      var that = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$confirm("确认保存？")
            .then(() => {
              save_invest(that.ruleForm).then((res) => {
                if (res.code === 200) {
                  this.$message({
                message: res.msg,
                type: "success",
              });
                  that.delImges();
                  that.$message.success("保存成功！");
                }
              });
            })
            .catch(() => {});
        } else {
          this.$nextTick(() => {
            that.elFormErrorScrollIntoView();
          });

          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs.ruleForm.resetFields();
      this.drawer = false;
    },
  },
};
</script>
<style lang="scss" scoped>
// .el-button {
//   color: #000 !important;
// }
::v-deep .el-drawer__body {
  padding-right: 20px;
  overflow: auto;
}
.table-box {
  margin-top: 20px;
}
.video-box {
  width: 148px;
  height: 148px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  video {
    width: 100%;
    height: 100%;
  }
  &:hover {
    .handles {
      opacity: 1;
    }
  }
  .handles {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 3;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;
    .el-icon-delete {
      font-size: 20px;
      color: #fff;
    }
  }
}
.avatar-uploaders {
  width: 80px;
  height: 80px;
  text-align: center;
  border: 1px solid #d9d9d9;
  line-height: 90px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.tableIcon {
  width: 50px;
  height: 50px;
}
.screenInput {
  width: 200px;
  margin: 0 10px;
}
.w4 {
  width: 40%;
}
::v-deep .el-table .el-table__body td .cell:empty::after,
.el-table .el-table__body td .cell > span:empty::after,
.el-table .el-table__body td .cell .approval:empty::after,
.el-table .el-table__body td .cell div:empty::after,
.el-table .el-table__body td .cell .line-limit-length:empty::after {
  content: "--";
}
.numInput {
  ::v-deep .el-input__inner {
    padding-right: 0 !important;
  }
}
</style>
